import EstablishmentProfile from 'modules/dashboard/profile/EstablishmentProfile'
import ProducerProfile from 'modules/dashboard/profile/ProducerProfile'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import RightSlotProfile from 'modules/dashboard/profile/right-slot/RightSlotProfile'
import RightSlotProducerProfile from 'modules/dashboard/profile/right-slot/RightSlotProducerProfile'
import EstablishmentProvider from 'context/establishments/Establishment'
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash'
import ShowAllEventsProvider from 'context/dash/ShowAllEvents'
import EstablishmentTagsProvider from 'context/establishments/EstablishmentTags'
import BackButtonCollapseProvider from 'context/general/BackButtonCollapse'
import DetailVisibleProvider from 'context/dash/DetailVisible'
import paths from 'routes/paths'

export default function DashProfile() {

  const location = useLocation()
  const [editProfileClick, setEditProfileClick] = useState(0)
  const [hasProducerProfile, setHasProducerProfile] = useState(false)

  // Quem tem os dois painéis (estabelecimento e admin) vê o perfil de cada um
  // no seu painel: /painel/estabelecimento/perfil e /painel/produtor/perfil.
  const isProducer = !location.pathname.startsWith(paths.dashboard.establishment.root)

  function rightSlotContent() {
    if (isProducer) {
      return (
        <RightSlotProducerProfile
          hasProfile={hasProducerProfile}
          onEditProfile={() => setEditProfileClick(editProfileClick + 1)}
        />
      )
    }

    return (
      <RightSlotProfile onEditProfile={() => setEditProfileClick(editProfileClick + 1)} />
    )
  }

  if (isProducer) {
    return (
      <DashContainer title={'Produtor'} rightSlot={() => rightSlotContent()}>
        <ProducerProfile editProfileClick={editProfileClick} onProfileLoaded={setHasProducerProfile} />
      </DashContainer>
    )
  }

  return (
    <BackButtonCollapseDashProvider>
      <DetailVisibleProvider>
        <EstablishmentTagsProvider>
          <ShowAllEventsProvider>
            <EstablishmentProvider>
              <BackButtonCollapseProvider>

                <DashContainer title={'Estabelecimento'} rightSlot={() => rightSlotContent()}>
                  <EstablishmentProfile editProfileClick={editProfileClick} />
                </DashContainer>

              </BackButtonCollapseProvider>
            </EstablishmentProvider>
          </ShowAllEventsProvider>
        </EstablishmentTagsProvider>
      </DetailVisibleProvider>
    </BackButtonCollapseDashProvider>
  )
}
